import React, { Component } from 'react';
import ReactTable from 'react-table';
import { sessionsTableSkeletonScreen } from '../../../SkeletonScreens/SkeletonScreen';
import './VirtualEventsTable.css';
import { connect } from 'react-redux';
import { denormalizeVirtualEvents } from '../../../Reducks/VirtualEvents/VirtualEventsUtils';
import { CHECKBOX, VALUE_ADD } from '../../../Telemetry/Mixpanel/Constants/mixpanelConstants';
import {
  trackAnalyticsFeature,
  trackAnalyticsGenerateReportFeature
} from '../../../Telemetry/Mixpanel/Features/analyticsTracker';
import { HeaderSortComponent } from '../../../Scss/Custom/ReactTable/HeaderSortComponent';
import { actions } from '../../../Reducks/VirtualEvents/index';
import {
  dateFormatterWithTimezone,
  dateSorter,
  getVirtualEventsData,
  startTimeFormatter,
  startTimeSorter,
  endTimeFormatter,
  endTimeSorter
} from '../../../Utils/TableUtil';
import { MAX_VE_SELECTED } from '../../../Utils/Constants';
import PropTypes from 'prop-types';
import SimpleSearchBox from '../../../Components/SearchBox/SimpleSearchBox';

export class VirtualEventsTable extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    virtualEvents: PropTypes.object,
    toggleVirtualEvent: PropTypes.func,
    filterVirtualEvents: PropTypes.func,
    reportType: PropTypes.string,
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired,
      reportType: PropTypes.string
    })
  };

  render() {
    const { fetching, virtualEvents, filtering } = this.props.virtualEvents;
    const filteredVirtualEvents = denormalizeVirtualEvents(virtualEvents.filteredKeys, virtualEvents.byKey);
    return (
      <div className="virtualEventsTableSection">
        {this.getSearchBox()}
        {fetching || filtering ? (
          sessionsTableSkeletonScreen()
        ) : (
          <div>
            <React.Fragment>{this.getVirtualEventsTable(filteredVirtualEvents)}</React.Fragment>
          </div>
        )}
      </div>
    );
  }

  getVirtualEventsTable = filteredVirtualEvents => {
    const { reportType } = this.props;
    return (
      <ReactTable
        keyField="virtualEventKey"
        data={getVirtualEventsData(filteredVirtualEvents, reportType)}
        columns={this.getVirtualEventColumns()}
        defaultPageSize={filteredVirtualEvents.length}
        minRows={5}
        style={{ height: '270px' }}
        showPagination={false}
        className="-highlight"
      />
    );
  };

  getSearchBox = () => {
    const { mixpanelData } = this.props;
    const { t } = this.context;
    const { filter } = this.props.virtualEvents;
    return (
      <SimpleSearchBox
        searchString={filter.searchString}
        placeHolder={t('virtualEvents.search')}
        onSearchInputChange={value => this.props.filterVirtualEvents({ searchString: value })}
        mixpanelData={mixpanelData}
      />
    );
  };

  checkBoxHeaderFormatter = (selectedCount, allVECount) => {
    return (
      <input
        type="checkbox"
        checked={selectedCount !== 0 && (selectedCount === allVECount || selectedCount === MAX_VE_SELECTED)}
        onChange={this.onCheckSelectAll}
      />
    );
  };

  onCheckSelectAll = e => {
    console.log('e', e);
    this.props.toggleAllVirtualEvents(e.target.checked);
  };

  getVirtualEventColumns = () => {
    const { t } = this.context;
    const {
      virtualEvents: { filteredSelectedVirtualEventKeys, allKeys }
    } = this.props.virtualEvents;
    return [
      {
        accessor: '',
        Cell: this.checkBoxCellFormatter,
        Header: this.checkBoxHeaderFormatter(filteredSelectedVirtualEventKeys.length, allKeys.length),
        sortable: false,
        width: 35,
        resizable: false,
        style: { textAlign: 'center' },
        headerStyle: { textAlign: 'center' }
      },
      {
        accessor: 'name',
        Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.name')} />,
        minWidth: 200
      },
      {
        accessor: 'date',
        Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.date')} />,
        Cell: cell => dateFormatterWithTimezone(cell.value.dateTime, cell.value.timeZone),
        sortMethod: dateSorter
      },
      {
        accessor: 'startTime',
        Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.startTime')} />,
        Cell: startTimeFormatter,
        sortMethod: startTimeSorter
      },
      {
        accessor: 'endTime',
        Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.endTime')} />,
        Cell: endTimeFormatter,
        sortMethod: endTimeSorter
      },
      {
        accessor: 'registrants',
        Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.registrants')} />
      }
    ];
  };

  checkBoxCellFormatter = ({ original }) => {
    const { virtualEvents } = this.props.virtualEvents;
    const isSelected = virtualEvents.filteredSelectedVirtualEventKeys.includes(original.virtualEventKey);
    const isMaxSelected = virtualEvents.filteredSelectedVirtualEventKeys.length === MAX_VE_SELECTED;
    return (
      <input
        type="checkbox"
        checked={isSelected}
        onChange={e => {
          trackAnalyticsFeature(VALUE_ADD, this.props.mixpanelData.action, CHECKBOX);
          if (this.props.mixpanelData.reportType) {
            trackAnalyticsGenerateReportFeature(this.props.mixpanelData.reportType, CHECKBOX);
          }
          this.props.toggleVirtualEvent(original.virtualEventKey, e.target.checked);
        }}
        disabled={isMaxSelected && !isSelected}
      />
    );
  };
}

export default connect(
  state => ({ virtualEvents: state.reduced_virtual_events }),
  {
    toggleVirtualEvent: actions.toggleVirtualEvent,
    filterVirtualEvents: actions.filterVirtualEvents,
    toggleAllVirtualEvents: actions.toggleAllVirtualEvents
  }
)(VirtualEventsTable);



// WEBPACK FOOTER //
// ./src/GoToWebinar/VirtualEvents/Table/VirtualEventsTable.js